"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CookieNames {
}
CookieNames.SELECTED_ORGANISATION_COOKIE = "selected_organisation";
CookieNames.SELECTED_ORGANISATION_NAME_COOKIE = "selected_organisation_name";
CookieNames.SELECTED_AUTH_NO_COOKIE = "selected_auth_no";
CookieNames.REQUESTED_ROLE_COOKIE = "requested_role";
CookieNames.REQUESTED_ROLE_SYSTEM_RESTRICTION_LIST_COOKIE = "requested_role_system_restriction_list";
CookieNames.PROFILE_COOKIE = "selected_profile";
CookieNames.ON_BEHALF_OF_CPR = "on_behalf_of_cpr";
CookieNames.REQUEST_PURPOSE_COOKIE = "request_purpose";
CookieNames.SBOV2_MARKER = "sbov2";
CookieNames.SBOV2_UNKNOWN_ORG = "sbov2_unknown_org";
CookieNames.PRESCRIPTION_PHONE_NO_COOKIE = "prescription_phone_number";
CookieNames.FAVORITE_ORGANIZATIONS_COOKIE = "favorite_organization";
CookieNames.FMK_ONLINE_VERSION = "fmk-online-version";
CookieNames.DARK_MODE = "dark_mode";
exports.default = CookieNames;
//# sourceMappingURL=CookieNames.js.map